var exports = {
  "wk": "AuthBrandPanel.module__brand___RFcxcj",
  "D_": "AuthBrandPanel.module__identity___RFcxcj",
  "wm": "AuthBrandPanel.module__logo___RFcxcj",
  "Y4": "AuthBrandPanel.module__textTier___RFcxcj",
  "Nr": "AuthBrandPanel.module__card___RFcxcj",
  "Ss": "AuthBrandPanel.module__wordmark___RFcxcj",
  "Hc": "AuthBrandPanel.module__host___RFcxcj",
  "Hw": "AuthBrandPanel.module__mobile___RFcxcj",
  "lD": "AuthBrandPanel.module__split___RFcxcj",
};

module.exports = exports;
